import React from 'react';
import { SERVICES } from '../../data/site';
import { Reveal } from '../Reveal';
import { SectionHeading } from '../SectionHeading';
export function Stage() {
  return <section id="stage" className="relative mx-auto w-full max-w-7xl px-5 py-20 sm:px-8 sm:py-28" data-id="element-318" data-mp="2wyvjynikixft">
      <SectionHeading eyebrow="EVENT PRODUCTION" title={<>
            We build the <span className="text-gradient" data-id="element-320" data-mp="36x1jwzktdti1">whole show</span>
          </>} description="From the deck up: structure, light, sound, screens and the crew that calls it." data-id="element-319" data-mp="31xype92gn5ob" />

      <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-321" data-mp="3awagec78o5ha">
        {SERVICES.map((service, i) => <Reveal key={service.title} delay={i * 0.06} className={i === 0 ? 'h-full lg:col-span-2' : 'h-full'} data-id="element-322" data-mp="3ko6psjerzi0t" data-mpi={i}>
            <article className="glass group flex h-full flex-col rounded-2xl p-6 transition-[transform,border-color,box-shadow] duration-300 ease-expo hover:-translate-y-1.5 hover:border-cyan/50 hover:shadow-neon-cyan" data-id="element-323" data-mp="3ppdv8btg454b">
              <span className="font-tech text-[0.65rem] tracking-[0.3em] text-cyan/70" data-id="element-324" data-mp="2jbogyjbpa8y">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-4 font-display text-[0.78rem] tracking-[0.1em] text-white sm:text-sm" data-id="element-325" data-mp="3oto0d4v6koyt">
                {service.title.toUpperCase()}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-white/55" data-id="element-326" data-mp="lcp8w9petyab">{service.detail}</p>
            </article>
          </Reveal>)}
      </div>
    </section>;
}